import { Grid, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import MainContent from "./components/MainContent";

import Sidebar from "./components/Sidebar";

const useStyles = makeStyles((theme) => ({
  gridBox: {
    width: "auto",
    height: "auto",
    maxHeight: "700px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.between("lm", "lm")]: {
      height: "auto",
    },
    [theme.breakpoints.between("md", "md")]: {
      height: "auto",
    },
  },
}));

export default function NewsContent() {
  const classes = useStyles();
  const [tabButton, setTabButton] = useState(1);

  return (
    <Grid container spacing={5} className={classes.gridBox}>
      <Grid item md={3} xs={12}>
        <Sidebar tabButton={tabButton} setTabButton={setTabButton} />
      </Grid>
      <Grid item md={9} xs={12}>
        <MainContent tabButton={tabButton} />
      </Grid>
    </Grid>
  );
}
